import { type OmitIndexSignature } from 'type-fest';

import {
  applyPropsPatch,
  type CanvasElementType,
  type PartialPropsOf,
} from '@blaze-runtime/engine-domain';
import { ComparisonOperator } from '@blaze-shared/api-contracts-domain';
import { type InternalVisibilityExpressionState } from '@blaze-shared/datasets-domain';
import { type CanvasElementDataProperties } from '@blaze-shared/elements-domain';

export const HIDE_WHEN_NO_DATA: InternalVisibilityExpressionState = 'hideWhenNoData';

export function applyHideWhenEmpty<T extends CanvasElementType>(
  props: PartialPropsOf<T>,
  hideWhenEmpty: boolean | undefined,
): PartialPropsOf<T> {
  if (!hideWhenEmpty) {
    return props;
  }

  const existingData = (props as { data?: CanvasElementDataProperties[] }).data ?? [];
  const data: CanvasElementDataProperties[] = [
    ...existingData.filter((entry) => entry.key !== 'visible'),
    {
      key: 'visible',
      enabled: true,
      bindings: {},
      isCustomSelection: false,
      dataSource: {
        sourceType: 'expression',
        id: '',
        columns: [],
        expression: [
          {
            internalState: HIDE_WHEN_NO_DATA,
            columns: '$$inputValue["length"]',
            operator: ComparisonOperator.Gt,
            value: '0',
          },
        ],
      },
    },
  ];

  const patch = {
    content: { visible: { internalStates: [HIDE_WHEN_NO_DATA] } },
    data,
  };

  return applyPropsPatch(props, toGenericPropsPatch(patch));
}

function toGenericPropsPatch<T extends CanvasElementType>(patch: {
  content: { visible: { internalStates: InternalVisibilityExpressionState[] } };
  data: CanvasElementDataProperties[];
}): OmitIndexSignature<PartialPropsOf<T>> {
  return patch as OmitIndexSignature<PartialPropsOf<CanvasElementType>> as OmitIndexSignature<
    PartialPropsOf<T>
  >;
}
